import { createSlice } from '@reduxjs/toolkit';
import { auth } from '../../firebase/firebase';
import { onAuthStateChanged } from 'firebase/auth';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    currentUser: null,
    loading: true, // Important: initial loading state
    error: null
  },
  reducers: {
    setUser: (state, action) => {
      console.log('✅ userSlice - Setting user:', action.payload?.email);
      state.currentUser = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading: (state, action) => {
      console.log('🔄 userSlice - Setting loading:', action.payload);
      state.loading = action.payload;
    },
    setError: (state, action) => {
      console.log('❌ userSlice - Setting error:', action.payload);
      state.error = action.payload;
    },
    clearUser: (state) => {
      console.log('🧹 userSlice - Clearing user');
      state.currentUser = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const { setUser, setLoading, setError, clearUser } = userSlice.actions;

// Thunk for listening to authentication changes
export const listenToAuthChanges = () => (dispatch) => {
  console.log('🎯 userSlice - Starting Firebase auth listener');
  dispatch(setLoading(true));
  
  const unsubscribe = onAuthStateChanged(auth, (user) => {
    console.log('🔥 Firebase auth state changed - User:', user ? user.email : 'None');
    
    if (user) {
      console.log('✅ Firebase - User authenticated:', user.email);
      dispatch(setUser({
        uid: user.uid,
        email: user.email,
        displayName: user.displayName,
      }));
    } else {
      console.log('❌ Firebase - No user authenticated');
      dispatch(clearUser());
    }
  });

  console.log('🎧 userSlice - Auth listener registered');
  return unsubscribe;
};

export default userSlice.reducer;